import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import { useAccount } from "wagmi";
import { formatWalletAddress } from "../../utils/wallets";

export default function ChatHeader(props: { showHelp: () => any }) {
  const { address: walletAddress } = useAccount();
  return (
    <div className="flex flex-row items-center justify-between py-3 px-4 h-14">
      <div className="flex flex-col items-start justify-center">
        <h1 className="text-lg font-semibold text-gray-900 dark:text-white text-nowrap">
          Surface Area
        </h1>
      </div>

      <div className="flex space-x-2 items-center">
        {walletAddress && (
          <div
            className={
              "flex text-gray-900 dark:text-white text-center justify-center items-center flex-row gap-2"
            }
          >
            <span>Connected to: {formatWalletAddress(walletAddress)}</span>
          </div>
        )}
        <button onClick={() => props.showHelp()}>
          <QuestionMarkCircleIcon className="h-6 w-6 text-gray-900 dark:text-white" />
        </button>
      </div>
    </div>
  );
}
